export enum SiteLinkTarget {
    Internal = "Internal",
    External = "External",
}
